import type { ReactNode } from "react";
import { DefaultLayout } from "./DefaultLayout";
import "dayjs/locale/de-ch";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { UIProvider } from "../providers/UIProvider";

dayjs.locale("de-ch");
dayjs.extend(utc);

export default function AppShell({ children }: { children: ReactNode }) {
  return (
    <UIProvider>
      <DefaultLayout>{children}</DefaultLayout>
    </UIProvider>
  );
}
